import { inject, Injectable, NgZone } from '@angular/core';
import { BaseService } from './base-service';
import { UsuarioCouchBase, UsuarioMongo, UsuarioMySQL } from '../model/usuario';
import { environment } from '../../environments/environment';
import { HttpClient, httpResource } from '@angular/common/http';
import { firstValueFrom, Observable } from 'rxjs';
import { Quote } from '../model/quote';
import { Transaccion } from '../model/transaccion';

@Injectable({
  providedIn: 'root'
})
export class DhrQuarkusService extends BaseService{
  backendUrl: string = environment.backendUrl;


  constructor(private httpClient: HttpClient, private zone: NgZone) { 
    super();
    
  }

  getServerSendEventQuotes(): Observable<Quote> {
    return new Observable(observer => {
      const eventSource = new EventSource(this.backendUrl + 'quotes');
      eventSource.onmessage = (event) => {
        console.log('Received event:', event);
        const data: Quote = JSON.parse(event.data);
        observer.next(data);
      };
      eventSource.onerror = (error) => {
        observer.error(error);
      };
      // Se retorna una función de limpieza para cerrar la conexión cuando se complete la suscripción
      return () => {
        console.log('Closing EventSource connection');
        eventSource.close();
      };
    });
  }
  getServerSendEventHazelcast(): Observable<Quote> {
    return new Observable(observer => {
      const eventSource = new EventSource(this.backendUrl + 'hazelcast/stream');
      eventSource.onmessage = (event) => {
        console.log('Received event:', event);
        const data: Quote = JSON.parse(event.data);
        observer.next(data);
      };
      eventSource.onerror = (error) => {
        observer.error(error);
      };
      // Se retorna una función de limpieza para cerrar la conexión cuando se complete la suscripción
      return () => {
        console.log('Closing EventSource connection');
        eventSource.close();
      };
    });
  }

  async getUsersCouchBase(): Promise<UsuarioCouchBase[]> {
    
    try {
      console.log(`DhrService.getUsers()`);
      const resultado = await  firstValueFrom(this.httpClient.get<UsuarioCouchBase[]>(this.backendUrl + 'couchbase/'));
      return resultado;
    } catch (error) {
        console.error('Error en la petición:', error);
        throw error
    } 
  }
  readonly usersCouchBaseResource = httpResource<Array<UsuarioCouchBase>>(() => ({
      url: this.backendUrl + 'couchbase/',
      method: 'GET',
      responseType: 'application/json',
  })); 
  readonly usersMongoResource = httpResource<Array<UsuarioMongo>>(() => ({
      url: this.backendUrl + 'mongo/',
      method: 'GET',
      responseType: 'application/json',
  })); 
  readonly usersMysqlResource = httpResource<Array<UsuarioMySQL>>(() => ({
      url: this.backendUrl + 'mysql/',
      method: 'GET',
      responseType: 'application/json',
  }));  
  requestKafkaQuote(): Observable<string> {
    console.log(`DhrService.requestKafkaQuote()`);
    return this.httpClient.get(this.backendUrl + 'quotes/request', { responseType: 'text' });
  }

  requestStreamProducer(): Observable<any> {
    console.log(`DhrService.requestStreamProducer()`);
    return this.httpClient.get(this.backendUrl + 'stream-producer', { responseType: 'text' });
  }

  getServerSendEventStreamReceiver(): Observable<Transaccion> {
    return new Observable(observer => {
      console.log(`DhrService.getServerSendEventStreamReceiver()`);
      const eventSource = new EventSource(this.backendUrl + 'stream-receiver');
      eventSource.onmessage = (event) => {
        console.log('Received stream event stream-receiver:', event);
        const data: Transaccion = JSON.parse(event.data);
        observer.next(data);
      };
      eventSource.onopen = () => {
        console.log('EventSource connection opened for stream-receiver');
      }
      eventSource.onerror = (error) => {
        console.error('Error in EventSource connection for stream-receiver:', error);
        observer.error(error);
      };
      return () => {
        console.log('Closing EventSource connection for stream-receiver');
        eventSource.close();
      };
    });
  }

  insertOrUpdateUserCouchBase(usuario: Partial<UsuarioCouchBase>): Observable<UsuarioCouchBase> {
    console.log(`DhrService.insertOrUpdateUserCouchBase(${usuario.usuario_id})`);
    return this.httpClient.post<UsuarioCouchBase>(this.backendUrl + 'couchbase/', usuario);
  }
  insertOrUpdateUserMysql(usuario: Partial<UsuarioMySQL>): Observable<UsuarioMySQL> {
    console.log(`DhrService.insertOrUpdateUserMysql(${usuario.usuario_id})`);
    return this.httpClient.post<UsuarioMySQL>(this.backendUrl + 'mysql/', usuario);
  }
  insertOrUpdateUserMongo(usuario: Partial<UsuarioMongo>): Observable<UsuarioMongo> {
    console.log(`DhrService.insertOrUpdateUserMongo(${usuario.id})`);
    return this.httpClient.post<UsuarioMongo>(this.backendUrl + 'mongo/', usuario);
  }
  deleteUserCouchBase(usuarioId: number): Observable<any> {
    console.log(`DhrService.deleteUserCouchBase(${usuarioId})`);
    return this.httpClient.delete(this.backendUrl + `couchbase/${usuarioId}`);
  } 
  deleteUserMysql(usuarioId: number): Observable<any> {
    console.log(`DhrService.deleteUserMysql(${usuarioId})`);
    return this.httpClient.delete(this.backendUrl + `mysql/${usuarioId}`);
  } 
  deleteUserMongo(usuarioId: string): Observable<any> {
    console.log(`DhrService.deleteUserMongo(${usuarioId})`);
    return this.httpClient.delete(this.backendUrl + `mongo/${usuarioId}`);
  } 
  async getUserCouchBase(id: number): Promise<UsuarioCouchBase> {
    
    try {
      console.log(`DhrService.getUser(${id})`);
      const resultado = await  firstValueFrom(this.httpClient.get<UsuarioCouchBase>(this.backendUrl + `couchbase/${id}`));
      return resultado;
    } catch (error) {
        console.error('Error en la petición:', error);
        throw error
    }
      
  }
  hello():Observable<any> {
    return this.httpClient.get(this.backendUrl + '/dhr', { responseType: 'text' });
  }
  vertxEventBus(message: string):Observable<any> {
    return this.httpClient.get(this.backendUrl + 'vertx/event-bus?mensaje=' + message, { responseType: 'text' });
  }
  vertxExternalService(url: string):Observable<any> {
    return this.httpClient.get(this.backendUrl + 'vertx/external-service?url=' + encodeURIComponent(url), { responseType: 'text' });
  }
  /*
  helloResource():Observable<any> {

    return this.http.get(this.backendUrl + '/dhr', { responseType: 'text' });

  }
    */
  
//readonly usersResourceCouch = httpResource<Array<Usuario>>(() => this.backendUrl + 'couchbase/', );
//readonly helloResource = httpResource<string>(() => this.backendUrl + '/dhr', );
readonly helloResource = httpResource.text(() => ({

    url: this.backendUrl + '/dhr',
    method: 'GET',
    responseType: 'text/plain',
}));  

readonly vertxLoadFileResource = httpResource.text(() => ({

    url: this.backendUrl + 'vertx/small-file',
    method: 'GET',
    responseType: 'text/plain',
}));
readonly vertxLoadFileBigResource = httpResource.text(() => ({

    url: this.backendUrl + 'vertx/big-file',
    method: 'GET',
    responseType: 'text/plain',
}));
  
/*
helloResource3 = httpResource(() => ({
  sayHello: () => ({
    url: this.backendUrl + '/dhr',
    method: 'GET',
    responseType: 'text',
  })

})); 
*/
/*
helloResource = httpResource(() => ({

    url: this.backendUrl + '/dhr',
    method: 'GET',
    responseType: 'text',
 
})); 
helloResource2 = inject(httpResource).defineRequests(
  {
    sayHello: () => ({
      url: this.backendUrl + '/dhr',
      method: 'GET',
      responseType: 'text',
    })
  }
);
*/
  // Define other methods as needed


 

  async helloAsync(): Promise<string> {
    try {
      const response = await firstValueFrom(this.hello());
      return response;
    } catch (error) {
      console.error('Error in helloAsync:', error);
      throw error;
    }
  }

}
